import { useAppRouter } from '@/shared/hooks/app/useAppRouter';

export const useConsoleApi = () => {
  const router = useAppRouter();

  return {
    router: (url: string) => router.push(url),
  };
};
